import { lazyLoadAnalytics } from '../../../../Common/Resources/src_front/js/components/lazyLoadAnalytics';
import { gtm } from './components/analytics/gtm';

document.addEventListener('DOMContentLoaded', function () {
    lazyLoadAnalytics(gtm);
});
